<template>
  <div
    class="flex flex-col md:flex-row gap-8 md:gap-16 px-24 pb-24"
    :class="[
      `${!active ? ' bg-surface-modal' : ''}`,
      `${!active && step == '2' ? 'pt-24' : ''}`,
    ]"
  >
    <div class="flex flex-row gap-8 md:gap-16">
      <div
        class="bg-surface-highlight w-32 h-32 flex justify-center items-center flex-none"
      >
        <p class="heading-xxs">{{ step }}</p>
      </div>
      <div>
        <p class="heading-xxs">{{ heading }}</p>
        <p>{{ text }}</p>
      </div>
    </div>

    <AppButton
      v-if="buttonText && active"
      class="w-full md:w-fit md:ml-auto"
      full-width
      color="primary"
      @on-click="showDrawer = true"
    >
      {{ buttonText }}
      <nuxt-icon name="recycle-heart-arrow" aria-hidden="true" />
    </AppButton>
  </div>
</template>

<script lang="ts" setup>
const showDrawer = defineModel<boolean>();
interface Props {
  step: string;
  heading: string;
  text: string;
  active: boolean;
  buttonText?: string;
}
defineProps<Props>();
</script>

<style></style>
